import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/attendance-settings',
        name: 'attendance-settings',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/administration/AttendSettings.vue'),
        meta: {
            title: 'Attendance Settings',
            breadcrumb: ['Administration', 'Attendance'],
            middleware: [GateKeeperMiddleware],
            ability: ({ gate }) => gate.allows('view', 'InstitutionSetting'),
        },
    },
];
